module.exports = __webpack_public_path__ + "288c5a7dfcd4e08d5047967f907984a5.fbx";